<template>
	<div class="mod-order">
		<div class="main" v-loading="modLoadding" element-loading-text="数据加载中,请稍后...">
			<!-- <div class="mod-title">
        <h1>订单详情</h1>
        <span class="under-line"></span>
      </div> -->
			<div class="modlist">
				<div class="stateImg" v-if="!modLoadding">
					<img src="@/assets/img/dtjbig.png" alt="" v-if="orderState == '1'" />
					<img src="@/assets/img/shz.png" alt="" v-if="orderState == '2'" />
					<img src="@/assets/img/ybh.png" alt="" v-if="orderState == '3'" />
					<img src="@/assets/img/xxfhbig.png" alt="" v-if="orderState == '4'" />
					<img src="@/assets/img/jyz.png" alt="" v-if="orderState == '6'" />
					<img src="@/assets/img/ywcbig.png" alt="" v-if="orderState == '8'" />
				</div>
				<section class="modinfo" v-if="extraInfo && extraInfo.failCause">
					<div class="topbox">
						<h3 class="modName">驳回原因</h3>
					</div>
					<div class="otherInfo">
						<el-row>
							<el-col :span="24">
								<p><span class="key">驳回原因：</span>{{ extraInfo.failCause }}</p>
							</el-col>
						</el-row>
					</div>
				</section>
				<section class="modinfo" v-if="extraInfo && extraInfo.apptInfo && (orderType == 'AUTONOMY_APP' || orderType == 'INSTRUMENT_APP')">
					<div class="topbox">
						<h3 class="modName">预约信息</h3>
					</div>
					<div class="otherInfo">
						<el-row>
							<el-col :span="12">
								<p><span class="key">创建时间：</span>{{ extraInfo.apptInfo.createTime }}</p>
							</el-col>
							<el-col :span="12">
								<p><span class="key">预约时段：</span>{{ extraInfo.apptInfo.startTime }} 至 {{ extraInfo.apptInfo.endTime }}</p>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<p><span class="key">预约类型：</span>{{ extraInfo.apptInfo.orderTypeVal }}</p>
							</el-col>
							<el-col :span="12">
								<p><span class="key">预约设备：</span>{{ extraInfo.goodsInfo.goodsName }}</p>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<p><span class="key">预约地点：</span>{{ extraInfo.goodsInfo.location }}</p>
							</el-col>
							<el-col :span="12">
								<p><span class="key">设备管理员：</span>{{ extraInfo.goodsInfo.deviceAdmin }}</p>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<p><span class="key">联系方式：</span>{{ extraInfo.goodsInfo.wechat }}</p>
							</el-col>
							<el-col :span="12"> </el-col>
						</el-row>
					</div>
				</section>
				<section class="modinfo" v-for="(mod, mindex) of modList" :key="mindex">
					<div class="topbox">
						<h3 class="modName">{{ mod.moduleName }} {{ mod.moduleNameEn == 'goodsInfo' ? mindex - 1 : '' }}</h3>
						<div class="btnfun" v-if="mod.moduleNameEn == 'goodsInfo' && orderState == '1'">
							<el-button type="text" round size="mini" v-if="modList.length > 3" @click="batchDel(modList)">批量删除</el-button>
							<el-button type="text" round size="mini" style="padding: 7px 0" @click="deleteHandle(mod)" v-if="mindex != 2">删除</el-button>
							<el-button type="text" round size="mini" @click="copyHandle(mod)">复制</el-button>
						</div>
					</div>
					<div class="itemList">
						<template v-if="mod.layout === 'FORM'">
							<d-form :dataForm="mod" :optionList="optionList" ref="Cform"></d-form>
						</template>
						<template v-if="mod.layout === 'TABLE'">
							<el-table
								:data="mod.data"
								border
								@selection-change="args => selectionItemsHandle(args, mindex)"
								@cell-click="(row, column, cell, event) => cellClick(row, column, cell, event, mod)"
								:header-cell-style="{ background: '#F2F3F5' }"
								size="mini"
								max-height="500"
								style="width: 100%; margin-bottom: 20px"
							>
								<el-table-column type="selection" :selectable="checkboxInit" :reserve-selection="true" header-align="center" align="center" width="50"> </el-table-column>
								<template v-for="(col, idx) of mod.header">
									<!-- <el-table-column :prop="col.field" :label="col.label" v-if="col.showed" header-align="center" align="center" :key="idx"> </el-table-column> -->
									<el-table-column :prop="col.field" :label="col.label" v-if="col.showed" header-align="center" align="center" :key="idx">
										<template scope="scope">
											<template v-if="col.options.disabled == false && (orderState == '1' || orderState == '3')">
												<el-input
													ref="canDditInput"
													v-model="scope.row[col.field]"
													class="edit-input"
													size="mini"
													@keyup.enter.native="enterBlur(scope)"
													@keyup.esc.native="esc(scope)"
												/>
											</template>
											<span v-else>{{ scope.row[col.field] }}</span>
										</template>
									</el-table-column>
								</template>
							</el-table>
						</template>
						<template v-if="mod.childrenList && mod.childrenList.length > 0">
							<section class="modinfo" v-for="(child, cindex) of mod.childrenList" :key="cindex">
								<div class="topbox">
									<h3 class="modName">{{ child.moduleName }}</h3>
								</div>
								<div class="itemList">
									<template v-if="child.layout === 'FORM'">
										<d-form :dataForm="child" :optionList="optionList" ref="Cform"></d-form>
									</template>
									<template v-if="child.layout === 'TABLE'">
										<el-table
											:data="child.data"
											ref="itemTable"
											border
											@selection-change="args => selectionItemsHandle(args, cindex, mindex, child.data)"
											@cell-click="(row, column, cell, event) => cellClick(row, column, cell, event, child)"
											:header-cell-style="{ background: '#F2F3F5' }"
											size="mini"
											max-height="500"
											style="width: 100%; margin-bottom: 20px"
										>
											<el-table-column :selectable="checkboxInit" :reserve-selection="true" type="selection" header-align="center" align="center" width="50"> </el-table-column>
											<template v-for="(col, idx) of child.header">
												<!-- <el-table-column :prop="col.field" :label="col.label" v-if="col.showed" header-align="center" align="center" :key="idx"> </el-table-column> -->

												<el-table-column :prop="col.field" :label="col.label" v-if="col.showed" header-align="center" align="center" :key="idx">
													<template scope="scope">
														<template v-if="col.options.disabled == false && (orderState == '1' || orderState == '3')">
															<el-input
																ref="canDditInput"
																v-model="scope.row[col.field]"
																class="edit-input"
																size="mini"
																:disabled="scope.row.isCanEdit"
																@keyup.enter.native="enterBlur(scope)"
																@keyup.esc.native="esc(scope)"
															/>
														</template>
														<span v-else>{{ scope.row[col.field] }}</span>
													</template>
												</el-table-column>
											</template>
										</el-table>
									</template>
								</div>
							</section>
						</template>
					</div>
				</section>
			</div>
			<section class="priceBox">
				<p>
					<span
						>预估总价：<span class="price">{{ costValTotal }} 元</span></span
					>
					<span v-if="orderState == '8' && extraInfo" style="margin-left: 20px"
						>实际总价：<span class="price">{{ extraInfo.totalValuation }} 元</span></span
					>
				</p>
			</section>
			<div class="btngroup">
				<template v-if="orderState == '1'">
					<el-button type="primary" round class="next" @click="deleteOrderHandle()">删除</el-button>
					<template v-if="orderType == 'AUTONOMY_APP' || orderType == 'INSTRUMENT_APP'">
						<el-button type="primary" round class="next" @click="changeTimeHandle()">更改时间</el-button>
					</template>
					<el-button type="primary" round class="next" @click="saveOrderHandle()">保存</el-button>
					<el-button type="primary" round class="next" @click="submitOrderHandle()">提交</el-button>
				</template>
				<template v-if="orderState == '2'">
					<el-button type="primary" round class="next" @click="revokeOrderHandle()">撤回</el-button>
				</template>
				<template v-if="orderState == '3'">
					<el-button type="primary" round class="next" @click="deleteOrderHandle()">删除</el-button>
					<!-- v-if="orderType == 'ENTRUST_DETN' || orderType == 'CNAS_DETN'" -->
					<template>
						<el-button type="primary" round class="next" @click="resubmitOrderHandle()">重新提交</el-button>
					</template>
				</template>
				<template v-if="orderState == '4'">
					<!-- <el-button type="primary" round class="next" @click="printOrderHandle()">打印</el-button> -->
					<el-button type="primary" round class="next" @click="repulseOrderHandle()">打回</el-button>
					<el-button type="primary" round class="next" @click="feedbackOrderHandle()">确认反馈</el-button>
				</template>
				<template v-if="orderState == '6'">
					<template v-if="orderType == 'ENTRUST_DETN' || orderType == 'CNAS_DETN'">
						<el-button type="primary" round class="next" @click="resampleOrderHandle()">再次送检</el-button>
						<el-button type="primary" round class="next" @click="contactAdminHandle()">联系管理员</el-button>
					</template>
					<template v-else>
						<el-button type="primary" round class="next" @click="contactAdminHandle()">联系管理员</el-button>
						<el-button type="primary" round class="next" @click="cancelReservationHandle()">取消预约</el-button>
						<el-button type="primary" round class="next" @click="changeTimeHandle()">更改时间</el-button>
					</template>
				</template>
				<template v-if="orderState == '8'">
					<el-button type="primary" round class="next" @click="resampleOrderHandle()">再次送检</el-button>
					<el-button v-if="extraInfo && !extraInfo.isUpdate && extraInfo.reportType == 'BGXS_ZSBG'" type="primary" round class="next" @click="downloadReport()">下载报告</el-button>
					<el-button v-if="extraInfo && !extraInfo.isUpdate && (extraInfo.reportType == 'BGXS_JCSJ' || extraInfo.reportType == 'BGXS_ZSBG')" type="primary" round class="next" @click="downloadData()"
						>下载数据</el-button
					>
					<el-button v-if="extraInfo && extraInfo.isUpdate" type="primary" round class="next" @click="renewHandle()">更新</el-button>
					<el-button type="primary" round class="next" @click="deleteOrderHandle()">删除</el-button>
				</template>
			</div>
		</div>
		<!-- 提交成功 -->
		<order-success v-if="orderSuccessVisible" ref="orderSuccess" @setOrderInit="setOrderInit"></order-success>
		<!-- 预约失败 -->
		<order-fail v-if="orderFailVisible" ref="orderFail" @showTimePanel="showTimePanel"></order-fail>
		<!-- 时间面板 -->
		<timepanel v-if="timepanelVisible" ref="timepanel" @updateTime="updateTime"></timepanel>
		<!-- 复制几份 -->
		<order-copy-num ref="orderCopyNum" @copyNumHandle="copyNumHandle"></order-copy-num>
		<!-- 下载附件列表 -->
		<order-down ref="orderDown" :downList="downList" @handleDown="handleDown"></order-down>

		<!-- 批量删除样品 -->
		<OrderSampleDel ref="orderSampleDel" :delModDt="delModDt" @batchDelHandle="batchDelHandle"></OrderSampleDel>
	</div>
</template>

<script>
import DForm from '@/components/DForm/DForm'
import OrderSuccess from '@/views/common/dialog/OrderSuccess'
import OrderFail from '../common/dialog/OrderFail.vue'
import Timepanel from '../common/Timepanel.vue'
import OrderCopyNum from './../common/dialog/OrderCopyNum.vue'
import OrderDown from './../common/dialog/OrderDown.vue'
import OrderSampleDel from './../common/dialog/OrderSampleDel.vue'
import { downloadFile } from '@/utils'
import { debounce } from '@/utils/common1'
export default {
	components: {
		DForm,
		OrderSuccess,
		OrderFail,
		Timepanel,
		OrderCopyNum,
		OrderDown,
		OrderSampleDel,
	},
	data() {
		return {
			orderId: '',
			orderState: '',
			orderType: '',
			goodsPrn: '',
			modLoadding: false,
			modList: null,
			extraInfo: null,
			dataListSelections: [],
			costValTotal: 0,
			orderSuccessVisible: false,
			orderFailVisible: false,
			timepanelVisible: false,

			copyModDt: null,
			copyNum: 0,
			downList: [],
			optionList: [],
			delModDt: [],
		}
	},
	computed: {
		surveyVisible: {
			get() {
				return this.$store.state.surveyVisible
			},
			set(val) {
				this.$store.commit('updateSurveyVisible', val)
			},
		},
	},
	created() {
		this.orderId = this.$route.query.orderId
		this.orderState = this.$route.query.st
		this.orderType = this.$route.query.type
		this.goodsPrn = this.$route.query.prn || ''
		// console.log(this.orderType, this.orderState, 'orderTypeorderType')
		this.init()
		this.getStandList()
	},

	methods: {
		checkboxInit() {
			if (this.orderState == '1' || this.orderState == '3') {
				return true
			} else {
				return false
			}
		},
		// 批量删除样品
		batchDel(modList) {
			this.$refs.orderSampleDel.dialogVisible = true
			// console.log(modList,'modddddddd')
			let dt = JSON.parse(JSON.stringify(modList))
			let arr = []
			this.delModDt = []
			dt.forEach(item => {
				item.template.forEach(it => {
					if (it.field == 'id') {
						arr.push(String(it.val))
					}
				})
			})
			this.delModDt = [...new Set(arr)].slice(1)
		},
		batchDelHandle: debounce(function (data) {
			if (data) {
				this.modLoadding = true
				this.updateOrder(this.delHandleBatch, data)
			}
		}, 300),
		// async batchDelHandle(data) {
		// 	if (data) {
		// 		this.modLoadding = true
		// 		await this.updateOrder(this.delHandleBatch, data)
		// 	}
		// },
		delHandleBatch(mod) {
			this.modLoadding = true
			let params = {
				orderId: this.orderId,
				templateGoodsIdList: mod,
			}
			this.$http
				.post(this.$api.orderApi.deleteGoods, params)
				.then(({ data }) => {
					console.log(data)
					this.$message({
						message: '操作成功',
						type: 'success',
						duration: 1500,
						onClose: () => {
							this.getModList(this.active)
						},
					})
				})
				.catch(() => {
					this.modLoadding = false
				})
		},

		getStandList() {
			let params = {
				current: 1,
				size: 10000,
				data: {
					orderId: this.orderId,
				},
			}
			this.$http
				.post(this.$api.goodsApi.funStdList, params)
				.then(({ data }) => {
					this.optionList = data.data.list
				})
				.catch(() => {
					this.modLoadding = false
				})
		},
		cellClick(row, column, cell, event, child) {
			console.log('cellClick=>', row, column, cell, event)
			console.log(child, 'childchildchild')
		},
		enterBlur(scope) {
			console.log(scope, 'scopescope')
		},
		esc(scope) {
			console.log(scope, 'scopescope')
			// scope.row[scope.column.property + 'show'] = false
			// scope.row.inventoryShow = false
		},
		init() {
			this.getModList()
		},
		getModList() {
			this.modLoadding = true
			this.modList = null
			this.costValTotal = 0
			this.dataListSelections = []
			let params = {
				orderId: this.orderId,
				stepKey: 'ORDER_XQ',
			}
			this.$http
				.post(this.$api.orderApi.orderInfo, params)
				.then(({ data }) => {
					this.modList = data.data.moduleSList
					this.extraInfo = data.data.extraInfo
					this.modLoadding = false

					this.modList.forEach(mod => {
						if (mod.childrenList && mod.childrenList.length > 0) {
							mod.childrenList.forEach(child => {
								if (child.layout == 'TABLE') {
									let select = []
									let data = child.data
									data.forEach(item => {
										if (item.st == '1') {
											select.push(item)
										}
										this.$set(item, 'isCanEdit', true)
									})

									this.dataListSelections.push(select)
								}
							})
						}
					})
					this.$nextTick(() => {
						this.dataListSelections &&
							this.dataListSelections.forEach((dt, i) => {
								dt.forEach(row => {
									this.$refs.itemTable[i] && this.$refs.itemTable[i].toggleRowSelection(row, true)
								})
							})
					})
					console.log(this.dataListSelections, '初始化表格勾选的数据2222')
					this.getygPrice()
					this.modLoadding = false
				})
				.catch(() => {
					this.modLoadding = false
				})
		},
		copyNumHandle: debounce(function (data) {
			this.modLoadding = true
			if (data) {
				this.modLoadding = true
				this.copyNum = data
				this.updateOrder(this.copymod, this.copyModDt)
			} else {
				this.modLoadding = false
			}
		}, 300),
		// async copyNumHandle(data) {
		// 	if (data) {
		// 		this.modLoadding = true
		// 		this.copyNum = data
		// 		await this.updateOrder(this.copymod, this.copyModDt)
		// 	}
		// },
		// 复制
		async copyHandle(mod) {
			Promise.all(this.batchFormVal(this.$refs.Cform, 'true'))
				.then(() => {
					this.$refs.orderCopyNum.dialogVisible = true
					this.copyModDt = mod
				})
				.catch(() => {
					this.$message.warning('请检查表单填写！')
					// console.log(err,'复制？')
				})
			// await this.updateOrder(this.copymod, mod)
		},
		copymod(mod) {
			this.modLoadding = true
			let goodsId = mod.list.filter(item => item.field == 'id')[0]['val']
			let params = {
				orderId: this.orderId,
				templateGoodsId: goodsId,
				number: Number(this.copyNum),
			}
			this.$http
				.post(this.$api.orderApi.copyGoods, params)
				.then(({ data }) => {
					console.log(data)
					this.$message({
						message: '操作成功',
						type: 'success',
						duration: 1500,
						onClose: () => {
							this.getModList()
						},
					})
				})
				.catch(() => {
					this.modLoadding = false
				})
		},
		// 删除
		deleteHandle(mod) {
			this.modLoadding = true
			this.updateOrder(this.delHandle, mod)
		},
		delHandle(mod) {
			this.modLoadding = true
			let goodsId = mod.list.filter(item => item.field == 'id')[0]['val']
			let params = {
				orderId: this.orderId,
				templateGoodsId: goodsId,
			}
			this.$http
				.post(this.$api.orderApi.deleteGoods, params)
				.then(({ data }) => {
					console.log(data)
					this.$message({
						message: '操作成功',
						type: 'success',
						duration: 1500,
						onClose: () => {
							this.getModList()
						},
					})
				})
				.catch(() => {
					this.modLoadding = false
				})
		},
		// 更新订单
		updateOrder(cb, args) {
			console.log(cb, args, 'argsargsargsargs')
			// return
			if (this.$refs.Cform) {
				Promise.all(this.batchFormVal(this.$refs.Cform, 'true'))
					.then(res => {
						let obj = {}
						res.map(item => {
							if (item.moduleNameEn == 'goodsInfo' || item.moduleNameEn == 'funStdInfo') {
								if (!obj[item['moduleNameEn']]) {
									obj[item['moduleNameEn']] = []
								}
								obj[item['moduleNameEn']].push(item)
							} else {
								obj[item['moduleNameEn']] = item
							}
						})
						let params = {
							orderId: this.orderId,
							...obj,
						}
						params['project'] = this.dataListSelections.reduce((a, b) => a.concat(b))

						console.log(params, '保存订单的参数')

						// return
						this.$http
							.post(this.$api.orderApi.updateOrder, params)
							.then(() => {
								if (cb) {
									this.modLoadding = true
								} else {
									this.modLoadding = false
								}
								cb && cb(args)
							})
							.catch(() => {
								this.modLoadding = false
							})
					})
					.catch(e => {
						this.$message.warning('请检查表单填写！')
						this.modLoadding = false
						console.log(e)
					})
			} else {
				this.modLoadding = false
			}
		},
		// 批量获取表单数据
		batchFormVal(forms, isRule) {
			let promises = []
			for (let i = 0; i < forms.length; i++) {
				promises.push(forms[i].getFormVal(isRule))
			}
			return promises
		},
		// 提交订单
		submitOrderHandle: debounce(function () {
			if (this.$refs.Cform) {
				Promise.all(this.batchFormVal(this.$refs.Cform))
					.then(res => {
						this.modLoadding = true
						console.log(res)
						let obj = {}
						// res.map(item => {
						// 	if (!obj[item['moduleNameEn']]) {
						// 		if (item['moduleNameEn'] == 'basicInfo' || item['moduleNameEn'] == 'businessRequirement') {
						// 			obj[item['moduleNameEn']] = item
						// 		} else {
						// 			obj[item['moduleNameEn']] = []
						// 			obj[item['moduleNameEn']].push(item)
						// 		}
						// 	}
						// })
						res.map(item => {
							if (item.moduleNameEn == 'goodsInfo' || item.moduleNameEn == 'funStdInfo') {
								if (!obj[item['moduleNameEn']]) {
									obj[item['moduleNameEn']] = []
								}
								obj[item['moduleNameEn']].push(item)
							} else {
								obj[item['moduleNameEn']] = item
							}
						})

						let params = {
							orderId: this.orderId,
							project: this.dataListSelections.reduce((a, b) => a.concat(b)),
							...obj,
						}
						console.log(params, '提交订单的参数')

						this.$http
							.post(this.$api.orderApi.orderSubmit, params)
							.then(({ data }) => {
								if (data.data && data.data.code == 0) {
									this.orderFailVisible = true
									this.$nextTick(() => {
										this.$refs.orderFail.init(this.orderId, this.orderType)
									})
								} else {
									if (data.code == 200) {
										this.orderSuccessVisible = true
										this.setOrderInit()
										this.$nextTick(() => {
											this.$refs.orderSuccess.init(this.orderId, this.orderType)
										})
									} else {
										this.orderFailVisible = true
										this.$nextTick(() => {
											this.$refs.orderFail.init(this.orderId, this.orderType)
										})
									}
								}
								this.modLoadding = false
							})
							.catch(() => {
								this.modLoadding = false
							})
					})
					.catch(() => {
						this.$message.warning('请检查表单填写！')
						this.modLoadding = false
					})
			} else {
				this.modLoadding = false
			}
		}, 300),

		// submitOrderHandle() {
		// 	this.modLoadding = true
		// 	if (this.$refs.Cform) {
		// 		this.modLoadding = true
		// 		Promise.all(this.batchFormVal(this.$refs.Cform)).then(res => {
		// 			console.log(res)
		// 			let obj = {}
		// 			res.map(item => {
		// 				if (!obj[item['moduleNameEn']]) {
		// 					if (item['moduleNameEn'] == 'basicInfo' || item['moduleNameEn'] == 'businessRequirement') {
		// 						obj[item['moduleNameEn']] = item
		// 					} else {
		// 						obj[item['moduleNameEn']] = []
		// 						obj[item['moduleNameEn']].push(item)
		// 					}
		// 				}
		// 			})
		// 			let params = {
		// 				orderId: this.orderId,
		// 				project: this.dataListSelections.reduce((a, b) => a.concat(b)),
		// 				...obj,
		// 			}
		// 			console.log(params, '提交订单的参数')

		// 			this.$http
		// 				.post(this.$api.orderApi.orderSubmit, params)
		// 				.then(({ data }) => {
		// 					if (data.data && data.data.code == 0) {
		// 						this.orderFailVisible = true
		// 						this.$nextTick(() => {
		// 							this.$refs.orderFail.init(this.orderId, this.orderType)
		// 						})
		// 					} else {
		// 						if (data.code == 200) {
		// 							this.orderSuccessVisible = true
		// 							this.$nextTick(() => {
		// 								this.$refs.orderSuccess.init(this.orderId, this.orderType)
		// 							})
		// 						} else {
		// 							this.orderFailVisible = true
		// 							this.$nextTick(() => {
		// 								this.$refs.orderFail.init(this.orderId, this.orderType)
		// 							})
		// 						}
		// 					}
		// 					this.modLoadding = false
		// 				})
		// 				.catch(() => {
		// 					this.modLoadding = false
		// 				})
		// 		}).catch(()=>{})
		// 	}else{
		// 		this.modLoadding = false
		// 	}
		// },
		setOrderInit() {
			console.log('??????')
			this.$router.push({ name: 'orderDetails', query: { orderId: this.orderId, st: '2', type: this.orderType, prn: this.goodsPrn } })
			this.orderState = '2'
			this.init()
			this.getStandList()
		},
		showTimePanel() {
			this.timepanelVisible = true
			this.$nextTick(() => {
				this.$refs.timepanel.init(this.goodsPrn, this.orderType, this.orderId)
			})
		},
		// 保存订单
		saveOrderHandle() {
			this.modLoadding = true
			this.updateOrder(() => {
				this.$message({
					message: '操作成功',
					type: 'success',
					duration: 1500,
					onClose: () => {
						this.modLoadding = false
						//this.$router.push({ name: "home" });
					},
				})
			})
		},
		//重新提交订单
		resubmitOrderHandle() {
			this.submitOrderHandle()
		},
		// 撤销订单
		revokeOrderHandle() {
			this.$confirm('是否确认撤回订单信息？', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				customClass: 'orderTips',
				type: 'warning',
			}).then(() => {
				let params = {
					orderId: this.orderId,
				}
				this.modLoadding = true
				this.$http
					.post(this.$api.orderApi.withdrawOrder, params)
					.then(() => {
						this.$message({
							message: '操作成功！',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.modLoadding = false
								this.$router.push({ name: 'myorder' })
							},
						})
					})
					.catch(() => {
						this.modLoadding = false
					})
			})
		},
		// 打回订单
		repulseOrderHandle() {
			this.$prompt('是否确认退回订单信息？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputType: 'textarea',
				inputPattern: /\S/,
				inputErrorMessage: '退回原因不能为空',
			})
				.then(({ value }) => {
					let params = {
						orderId: this.orderId,
						isReview: false,
						failCause: value,
					}
					this.modLoadding = true
					this.$http
						.post(this.$api.orderApi.orderReview, params)
						.then(({ data }) => {
							console.log(data)
							this.$message({
								message: '操作成功！',
								type: 'success',
								duration: 1500,
								onClose: () => {
									this.modLoadding = false
									this.$router.push({ name: 'myorder' })
								},
							})
						})
						.catch(() => {
							this.modLoadding = false
						})
				})
				.catch(() => {
					this.modLoadding = false
				})
		},
		// 打印订单
		printOrderHandle() {
			this.modLoadding = true
			this.$http
				.post(this.$api.orderApi.searchEntrustPdf, { orderId: this.orderId })
				.then(res => {
					console.log(res.data.data.filePreviewUrl, '打印ressssssss')
					this.modLoadding = false
					if (res.data.data && res.data.data.filePreviewUrl) {
						setTimeout(() => {
							window.open(res.data.data.filePreviewUrl, '_blank')
						}, 500)
					} else {
						this.$message.warning('暂无打印信息！')
					}
				})
				.catch(() => {
					this.modLoadding = false
				})
		},
		// 确认反馈订单
		feedbackOrderHandle() {
			this.$confirm('是否确认修改信息？', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				customClass: 'orderTips',
				type: 'warning',
			}).then(() => {
				let params = {
					orderId: this.orderId,
					isReview: true,
				}
				this.modLoadding = true
				this.$http
					.post(this.$api.orderApi.orderReview, params)
					.then(({ data }) => {
						console.log(data)
						this.$message({
							message: '操作成功！',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.modLoadding = false
								this.$router.push({ name: 'myorder' })
							},
						})
					})
					.catch(() => {
						this.modLoadding = false
					})
			})
		},
		//再次送检订单
		resampleOrderHandle() {
			let params = {
				orderId: this.orderId,
			}
			this.modLoadding = true
			this.$http
				.post(this.$api.orderApi.copyOrder, params)
				.then(() => {
					this.$message({
						message: '操作成功',
						type: 'success',
						duration: 1500,
						onClose: () => {
							this.modLoadding = false
							this.$router.push({ name: 'myorder' })
						},
					})
				})
				.catch(() => {
					this.modLoadding = false
				})
		},
		// 联系管理员
		contactAdminHandle() {
			this.modLoadding = true
			this.$http
				.get(this.$api.systemApi.getSys)
				.then(({ data }) => {
					console.log(data)
					this.modLoadding = false
					this.$alert(`联系电话：${data.data.consultPhone}`, '联系管理员', {
						confirmButtonText: '确定',
						callback: () => {},
					})
				})
				.catch(() => {
					this.modLoadding = false
				})
		},
		//取消预约
		cancelReservationHandle() {
			var startTime = this.extraInfo.apptInfo.startTime
			var times = new Date(startTime).getTime() - 1 * 60 * 60 * 1000
			var currentTime = new Date().getTime()
			if (this.orderType == 'AUTONOMY_APP' && currentTime - times > 0) {
				this.$alert('超出取消预约时限，暂不支持取消预约', '提示', {
					confirmButtonText: '确定',
					callback: () => {},
				})
				return
			}
			if (this.orderType == 'INSTRUMENT_APP' && currentTime - times * 48 > 0) {
				this.$alert('超出取消预约时限，暂不支持取消预约', '提示', {
					confirmButtonText: '确定',
					callback: () => {},
				})
				return
			}
			this.$prompt('是否确认取消预约？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputType: 'textarea',
				inputPattern: /\S/,
				inputErrorMessage: '备注信息不能为空',
			})
				.then(({ value }) => {
					let params = {
						orderId: this.orderId,
						cancelCause: value,
					}
					this.modLoadding = true
					this.$http
						.post(this.$api.orderApi.cancelAppt, params)
						.then(({ data }) => {
							console.log(data)
							this.$message({
								message: '操作成功！',
								type: 'success',
								duration: 1500,
								onClose: () => {
									this.modLoadding = false
									this.$router.push({ name: 'myorder' })
								},
							})
						})
						.catch(() => {
							this.modLoadding = false
						})
				})
				.catch(() => {
					this.modLoadding = false
				})
		},
		// 更改时间
		changeTimeHandle() {
			if (this.orderState == '6') {
				var startTime = this.extraInfo.apptInfo.startTime
				var times = new Date(startTime).getTime() - 1 * 60 * 60 * 1000
				var currentTime = new Date().getTime()
				if (this.orderType == 'AUTONOMY_APP' && currentTime - times > 0) {
					this.$alert('超出取消预约时限，暂不支持更改时间', '提示', {
						confirmButtonText: '确定',
						callback: () => {},
					})
					return
				}
				if (this.orderType == 'INSTRUMENT_APP' && currentTime - times * 48 > 0) {
					this.$alert('超出取消预约时限，暂不支持更改时间', '提示', {
						confirmButtonText: '确定',
						callback: () => {},
					})
					return
				}
			}

			this.timepanelVisible = true
			this.$nextTick(() => {
				this.$refs.timepanel.init(this.goodsPrn, this.orderType, this.orderId)
			})
		},
		updateTime(obj) {
			console.log(obj, this.orderState, this.orderType, 'CCCCCCCCCCCCCCCCCC')

			let params = {
				orderId: this.orderId,
				startTime: obj.startTime,
				endTime: obj.endTime,
			}
			if (this.orderState == '6') {
				if (this.orderType == 'AUTONOMY_APP' || this.orderType == 'INSTRUMENT_APP') {
					this.modLoadding = true
					this.$http
						.post(this.$api.orderApi.updateAppt, params)
						.then(({ data }) => {
							console.log(data)
							this.$message({
								message: '更改成功',
								type: 'success',
								duration: 1500,
								onClose: () => {
									this.getModList()
								},
							})
						})
						.catch(() => {
							this.modLoadding = false
						})
				}
			} else {
				this.modLoadding = true
				this.updateOrder(() => {
					this.$http
						.post(this.$api.orderApi.updateAppt, params)
						.then(({ data }) => {
							console.log(data)
							this.$message({
								message: '更改成功',
								type: 'success',
								duration: 1500,
								onClose: () => {
									this.getModList()
								},
							})
						})
						.catch(() => {
							this.modLoadding = false
						})
				})
			}
		},
		// 下载报告
		downloadReport() {
			this.modLoadding = true
			this.$http
				.post(this.$api.goodsApi.getReportUrl, { orderId: this.orderId })
				.then(res => {
					console.log(res, '下载报告ressssssss')
					let url = res.data.data.repDownUri
					if (url) {
						downloadFile(url, res.data.data.fileName)
						this.$http
							.get(this.$api.systemApi.getFirstReport)
							.then(res => {
								if (res.data.data.isFillQsa) {
									this.surveyVisible = true
								}
							})
							.catch(() => {})
					} else {
						this.$message.warning('暂未查询到报告内容!')
					}
					this.modLoadding = false
				})
				.catch(() => {
					this.modLoadding = false
				})
		},
		//下载数据
		downloadData() {
			this.modLoadding = true
			this.$http
				.post(this.$api.orderApi.searchAnnexByOrderId, { orderId: this.orderId })
				.then(res => {
					this.modLoadding = false
					this.downList = res.data.data
					if (Array.isArray(this.downList) && this.downList) {
						this.$refs.orderDown.dialogVisible = true
					} else {
						this.$message.warning('暂未查询到数据内容!')
					}
				})
				.catch(() => {
					this.modLoadding = false
				})
		},
		handleDown(v) {
			downloadFile(v.annexDownUri, v.fileName)
			this.$http
				.get(this.$api.systemApi.getFirstReport)
				.then(res => {
					if (res.data.data.isFillQsa) {
						this.surveyVisible = true
					}
				})
				.catch(() => {})
		},

		//更新
		renewHandle() {
			this.modLoadding = true
			this.$http
				.post(this.$api.orderApi.updateReport, { orderId: this.orderId })
				.then(res => {
					console.log(res, '更新ressssssss')
					this.getModList()
				})
				.catch(() => {
					this.modLoadding = false
				})
		},
		// 删除订单
		deleteOrderHandle() {
			this.$confirm(`确定进行[ "删除"]操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				this.modLoadding = true
				let params = {
					orderIds: [this.orderId],
				}
				this.$http
					.post(this.$api.orderApi.deleteOrder, params)
					.then(() => {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.$router.push({ name: 'myorder' })
							},
						})
					})
					.catch(() => {
						this.modLoadding = false
					})
			})
		},
		// 表格多选
		selectionItemsHandle(val, index, mindex, data) {
			let modIndex = this.modList.findIndex(v => v.moduleNameEn == 'goodsInfo')
			this.dataListSelections[mindex - modIndex] = val
			console.log(this.dataListSelections, '勾选表格后')
			data.forEach(item => {
				item.isCanEdit = true
			})
			data.forEach(v => {
				val.forEach(it => {
					if (it.id == v.id) {
						v.isCanEdit = false
					}
				})
			})
			this.getygPrice()
		},
		getygPrice() {
			let price = 0
			if (this.dataListSelections.length > 0) {
				this.dataListSelections.forEach(mod => {
					if (mod.length > 0) {
						mod.forEach(item => {
							if (item.costVal) price += parseFloat(item.costVal)
						})
					}
				})
			}
			this.costValTotal = price
		},
	},
}
</script>

<style lang="scss" scoped>
.mod-order {
	.main {
		.mod-title {
			text-align: center;
			overflow: hidden;
			h1 {
				font-size: 24px;
			}
			.under-line {
				display: inline-block;
				width: 32px;
				margin-top: 12px;
				border: 2px solid #1460ae;
				background: #1460ae;
				border-radius: 4px;
			}
		}
	}

	.modlist {
		padding: 20px 0;
		position: relative;
		.stateImg {
			position: absolute;
			right: -16px;
			top: -16px;
			img {
				width: 80px;
			}
		}
		.topbox {
			display: flex;
			justify-content: space-between;
			background: #f2f3f5;
			border-radius: 8px;
			margin-bottom: 20px;
			.modName {
				margin: 0;
				font-size: 14px;
				color: #333;
				padding: 6px 16px;
			}
			.btnfun {
				display: flex;
				align-items: center;
				text-align: center;
			}
		}
		.otherInfo {
			p {
				font-size: 14px;
				color: #606266;
				margin-top: 0;
				.key {
					display: inline-block;
					width: 100px;
					text-align: right;
				}
			}
		}
	}
	.moudlePanle {
		margin-bottom: 30px;
	}
	.priceBox {
		p {
			text-align: center;
			font-weight: bold;
			.price {
				color: #ff4713;
			}
		}
	}

	.btncontrol {
		position: relative;
		top: 6px;
		margin-left: 15px;
		width: 143px;
	}

	.btngroup {
		text-align: center;
		margin-top: 40px;

		button {
		}
	}
}
</style>
